export default __webpack_public_path__ + "static/media/logo.d1a00ae2.png";